import {BlogsPaginatedTake} from '@/libs/constants/common.constants';
import BlogSkeletonGrid from '@/components/sections/blogs/skeleton/BlogSkeletonGrid';
import BlogSkeleton from '@/components/sections/blogs/skeleton/BlogSkeleton';

export default function BlogSkeletonList({ isGrid = false }) {
	if (isGrid) {
		return (
				Array.from({length: BlogsPaginatedTake}).map((_, index) => (
						<div className="col-lg-4 col-sm-6 col-12" key={index}>
							<BlogSkeletonGrid/>
						</div>
				))
		)
	}
	return (
			Array.from({length: BlogsPaginatedTake}).map((_, index) => (
					<div className="col-lg-12" key={index}>
						<BlogSkeleton/>
					</div>
			))
	);
}
